module.exports = __webpack_public_path__ + "static/img/挖掘机.447f12f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/model/type-1/挖掘机.png
// module id = VuP3
// module chunks = 0